import { render, staticRenderFns } from "./MantenedorTramosPantalla.vue?vue&type=template&id=46d2f648&"
import script from "./MantenedorTramosPantalla.vue?vue&type=script&lang=ts&"
export * from "./MantenedorTramosPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('46d2f648', component.options)
    } else {
      api.reload('46d2f648', component.options)
    }
    module.hot.accept("./MantenedorTramosPantalla.vue?vue&type=template&id=46d2f648&", function () {
      api.rerender('46d2f648', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/MantenedorTramos/MantenedorTramosPantalla.vue"
export default component.exports